var a = Object.defineProperty;
var u = (s, r, e) => r in s ? a(s, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[r] = e;
var t = (s, r, e) => u(s, typeof r != "symbol" ? r + "" : r, e);
class o {
  constructor(r = "") {
    t(this, "value");
    t(this, "error");
    t(this, "errorMessage");
    this.value = r, this.error = !1, this.errorMessage = "";
  }
  setError(r) {
    const e = new o(this.value);
    return e.error = !0, e.errorMessage = r, e;
  }
}
export {
  o as default
};
//# sourceMappingURL=contact-channels14.js.map
